import { createSelectorFactory, defaultMemoize } from '@ngrx/store';

import { CandidateReferrer } from '@recruitee/http/types';
import { createEntityCollectionStore, memoizeSelector } from '@recruitee/ngrx';

const { actions, reducer, namespace, selectors } = createEntityCollectionStore<CandidateReferrer>()(
  'CandidateReferrer',
  {
    customActions: adapter => ({
      references: (state, payload: { data: CandidateReferrer[] }) =>
        adapter.updateOrCreateMany(state, payload.data),
    }),
  },
);

const CandidateReferrerActions: Pick<typeof actions, 'references'> = actions;

const CandidateReferrerSelectors = {
  ...selectors,
  byIds: memoizeSelector((referrersIds: number[]) =>
    createSelectorFactory(defaultMemoize)(
      ...(referrersIds || []).map(referrersIds => selectors.byId(referrersIds)),
      (...result: CandidateReferrer[]) => result,
    ),
  ),
};

export {
  CandidateReferrerActions,
  CandidateReferrerSelectors,
  reducer as CandidateReferrerReducer,
  namespace as CandidateReferrerNamespace,
};
